var UISelectButton = (function ($) {

    UISelectButton = function () {
        var that = this;

        // DOM

        // CONST
        that.class = {
            error: 'error',
        };

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UISelectButton.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UISelectButton.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('input', '.js-select-button-input', function () {
            var $input = $(this),
                $select_button = $input.parents('.js-select-button'),
                $error = $select_button.find('.js-error-content');

            $select_button.removeClass(that.class.error);
            setTimeout(function(){$error.text('')},300);
        });
    };

    return UISelectButton;
})($);
